import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  checkBoxItem: {
    display: 'flex',
    justifyContent: 'row',
    alignItems: 'center',
    '& .MuiFormControlLabel-label': {
      fontSize: theme.typography.h5.fontSize,
    },
  },
  collapseRow: {
    width: '100%',
  },
  collapseRowInner: {
    padding: theme.spacing(2, 0, 0, 2),
  },
}));

export default useStyles;
